import * as React from "react";

function SvgArrowIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}><path d="M59.4 177.5l82.4-82.4-82.4-82.3-10.6 10.6 71.8 71.7-71.8 71.8 10.6 10.6z" /></svg>;
}

export default SvgArrowIcon;